import { Link } from "react-router";
import { Pages } from "../../../utils";
import { MATCH_DIMENSIONS } from "./data";

export const MatchingSection = () => {
  return (
    <section className="match-section">
      <div className="match-copy">
        <div className="ey fi match-ey">
          <span className="match-ey-line" />Smart-Guild Matching™
        </div>
        <h2 className="st wh fi">
          Three dimensions.
          <br />
          <em>One perfect pairing.</em>
        </h2>
        <p className="lead wh fi">
          Finding the right interior designer has never been this precise. Our
          proprietary matching technology looks at the complete picture —
          because a great home project starts with a great working relationship.
        </p>
        <div className="fi" style={{ marginTop: "40px" }}>
          <Link to={Pages.SMART_GUILD_MATCHING} className="btn-rose-out">
            Smart-Guild Process →
          </Link>
        </div>
      </div>

      <div className="match-card-wrap fi">
        <div className="mc">
          <div className="mc-lbl">Smart-Guild Compatibility Score</div>

          {MATCH_DIMENSIONS.map((dimension) => (
            <div className="mc-d" key={dimension.name}>
              <div className="mc-dr">
                <span className="mc-dn">{dimension.name}</span>
                <span className="mc-dp">{dimension.percent}%</span>
              </div>
              <div className="mc-bg">
                <div
                  className="mc-fill"
                  style={{
                    width: `${dimension.percent}%`,
                    animationDelay: `${dimension.animationDelaySeconds}s`,
                  }}
                />
              </div>
            </div>
          ))}

          <div className="mc-tot">
            <span className="mc-tl">Overall Match Score</span>
            <span className="mc-ts">93%</span>
          </div>
          <div className="mc-v">HDG-Verified Match Ready</div>
        </div>
      </div>
    </section>
  );
};
